import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import Text from 'reusecore/src/elements/Text';
import { useAuth } from '../../contexts/AuthProvider';
import { Counter } from '../../helpers/Counter';
import { analytics, db } from '../../helpers/firebaseHelper';
import getPhotos, { LARGE, MEDIUM } from '../../helpers/getPhotos';
import useMediaQuery from '../../helpers/mediaQuery';
import { Certified } from "../Ads/certified";
import {
  ListViewWrapper,
  ImageWrapper,
  ContentWrap,
  AddressAndDate,
  SubCardInfosWrapper,
  SubCardDescriptionWrapper,
  SubCardTitleWrapper,
  SubCardPriceWrapper,
  SubCardCenterWrapper,
} from './listView.style';
import PlaceholderImage from '@core/ui/static/images/thumb-grid-placeholder.svg';
import { Carousel } from 'react-responsive-carousel';
import LazyLoad from 'react-lazyload';
import ReadMore from '../../components/Truncate';
import { dateFormat } from '../../helpers/dateHelper';
import NumberFormat from 'react-number-format';
import { CURRENCY } from '../../Config';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';
import { useMutation } from '@apollo/client';
import { HANDLE_FAV } from '@core/ui/graphql/Mutations';
import { openModal } from '@redq/reuse-modal';
import LoginModal from '../../containers/ModalContainer/LoginModal';
import { useUser } from '../../contexts/UserContext';
import Lightbox from 'react-image-lightbox';
import Link from 'next/link';
import { ROLE_ADMIN } from '@core/ui/role/const';
import icoLocation from '@core/ui/static/images/ico-location.svg';
import icoCalendar from '@core/ui/static/images/ico-calendar.svg';
import icoCat from '@core/ui/static/images/ico-cat.svg';
import heartO from '@core/ui/static/images/ico-fav-mini.svg';
import heart from '@core/ui/static/images/ico-fav-mini-filled.svg';
import { useTranslation } from 'next-i18next';
import { slugify } from '../../helpers/urlHandler';

// dynamic imports
const SkazyAdvertising = dynamic(() => import('../SkazyAdvertising'));

const ListView = ({ ...props }) => {
  const imageStyle = {};
  const { isLoggedIn } = useAuth();
  const { state } = useUser();
  const { favorites, userId } = state;
  const favoritesUser = favorites ? favorites : [];
  const [currImg, setCurrImg] = useState(0);
  const [viewIsOpen, setViewIsOpen] = useState(false);

  const isMobile = useMediaQuery('(max-width: 1023px)');

  const { source: media = [], photos } = props;

  const postGallery = getPhotos(media, photos, MEDIUM);
  let postGalleryLarge = getPhotos(media, photos, LARGE);

  postGalleryLarge = postGalleryLarge.map(photo => {
    const { thumbnail: { contentUrl } = {} } = photo;
    if (contentUrl) {
      photo.contentUrl = contentUrl;
    }

    return photo;
  });

  const { t } = useTranslation();

  const gotoNext = () => {
    setCurrImg((currImg + 1) % postGalleryLarge.length);
  };
  const gotoPrevious = () => {
    setCurrImg(
      (currImg + postGalleryLarge.length - 1) % postGalleryLarge.length
    );
  };
  const closeImgsViewer = () => {
    setViewIsOpen(false);
  };
  const getZoom = () => {
    setViewIsOpen(true);
  };

  let _getLeftHeaderComponent = () => {
    if (postGallery.length > 1) {
      return (
        <Carousel
          swipeable={true}
          infiniteLoop={true}
          showThumbs={false}
          showStatus={false}
          onClickItem={getZoom}
          selectedItem={currImg}
          onChange={index => setCurrImg(index)}
        >
          {postGallery.map((image, index) => {
            const {
              contentUrl,
              height = null,
              source = null,
              thumbnail,
              width = null,
            } = image;
            const {
              contentUrl: thumbnailContentUrl,
              height: thumbnailHeight = null,
              source: thumbnailSource = null,
              width: thumbnailWidth = null,
            } = thumbnail || {};

            const imgSrc = thumbnail ? thumbnailContentUrl : contentUrl;
            const imgHeight = thumbnail ? thumbnailHeight : height;
            const imgSource = thumbnail ? thumbnailSource : source;
            const imgWidth = thumbnail ? thumbnailWidth : width;

            return (
              <div key={index}>
                <picture>
                  {imgSource}
                  <img
                    src={imgSrc}
                    alt={props.title}
                    style={imageStyle}
                    height={imgHeight}
                    width={imgWidth}
                    loading="lazy"
                  />
                </picture>
              </div>
            );
          })}
        </Carousel>
      );
    } else {
      let imgSrc = PlaceholderImage;
      let imgSource = null;

      let imgHeight = null;
      let imgWidth = null;

      if (postGallery.length > 0) {
        const {
          contentUrl,
          height = null,
          source = null,
          thumbnail,
          width = null,
        } = postGallery[0];
        const {
          contentUrl: thumbnailContentUrl,
          height: thumbnailHeight = null,
          source: thumbnailSource = null,
          width: thumbnailWidth = null,
        } = thumbnail || {};

        imgSrc = thumbnail ? thumbnailContentUrl : contentUrl;
        imgHeight = thumbnail ? thumbnailHeight : height;
        imgSource = thumbnail ? thumbnailSource : source;
        imgWidth = thumbnail ? thumbnailWidth : width;
      }

      return (
        <LazyLoad
          placeholder={<img style={imageStyle} src={PlaceholderImage} alt="" />}
          offset={300}
          once
        >
          <picture>
            {imgSource}
            <img
              src={imgSrc}
              alt={props.title}
              style={imageStyle}
              height={imgHeight}
              width={imgWidth}
              loading="lazy"
            />
          </picture>
        </LazyLoad>
      );
    }
  };

  const alreadyFavorite = () => {
    const index = favoritesUser.indexOf(props.id);
    if (index > -1) {
      return true;
    }
    return false;
  };

  const [handleFavMutation] = useMutation(HANDLE_FAV, {
    variables: {
      fav: {
        id: userId,
        postId: props.id,
      },
    },
  });

  const handleFavourite = async e => {
    e.preventDefault();
    if (isLoggedIn) {
      await handleFavMutation();

      // analytics
      if (!alreadyFavorite() && typeof window !== 'undefined' && analytics) {
        analytics.logEvent('add_to_wishlist', {
          currency: CURRENCY,
          items: [
            {
              item_id: props.sid,
              item_name: props.title,
              item_category: props.category,
              price: props.price,
            },
          ],
          value: props.price,
        });

        // Initialize the sharded counter.
        const favoritesCounter = new Counter(
          db.collection('ads').doc(props.id),
          'stats.favorites'
        );

        // Increment the field "favorites" of the document
        favoritesCounter.incrementBy(1);
      }
    } else {
      // SHOW MODAL
      openModal({
        config: {
          disableDragging: false,
          minHeight: 'auto',
          width: 'auto',
          height: 'auto',
          enableResizing: true,
          transition: {
            tension: 150,
          },
        },
        springStyle: {
          backgroundColor: '#ffffff',
          overflowY: 'auto',
        },
        modalClass: 'loginModal',
        closeOnClickOutside: true,
        component: LoginModal,
        componentProps: {},
      });
    }
  };

  const price =
    process.browser && props.price > 0 ? (
      <SubCardPriceWrapper>
        <NumberFormat
          value={props.price}
          displayType={'text'}
          thousandSeparator={' '}
          renderText={value => (
            <Text mb={0} content={`${value} ${CURRENCY} `} />
          )}
        />
      </SubCardPriceWrapper>
    ) : null;

  const isAdmin = () => {
    const role = state.role;
    return role === ROLE_ADMIN;
  };

  return (
    <>
      {viewIsOpen && (
        <Lightbox
          mainSrc={postGalleryLarge[currImg].contentUrl}
          nextSrc={
            postGalleryLarge.length > 1
              ? postGalleryLarge[(currImg + 1) % postGalleryLarge.length]
                  .contentUrl
              : ''
          }
          prevSrc={
            postGalleryLarge.length > 1
              ? postGalleryLarge[
                  (currImg + postGalleryLarge.length - 1) %
                    postGalleryLarge.length
                ].contentUrl
              : ''
          }
          onCloseRequest={closeImgsViewer}
          onMovePrevRequest={gotoPrevious}
          onMoveNextRequest={gotoNext}
        />
      )}
      <ListViewWrapper>
        <ImageWrapper>
          {props.additionalType && props.additionalType === 'pro' && (
            <div
              style={{
                position: 'absolute',
                zIndex: 1,
                marginTop: 20,
                marginLeft: 10,
                display: 'flex',
              }}
            >
              <span
                style={{
                  backgroundColor: '#FFF',
                  border: 1,
                  borderColor: '#002F3F',
                  borderStyle: 'solid',
                  paddingLeft: 4,
                  paddingRight: 4,
                  fontSize: 12,
                  color: '#002F3F',
                  userSelect: 'none',
                }}
              >
                PRO
              </span>
            </div>
          )}
          {_getLeftHeaderComponent()}
        </ImageWrapper>
        <ContentWrap>
          <SubCardInfosWrapper>
            <Link href={`/${SEARCH_PAGE}/${slugify(props.category)}`}>
              <a style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', marginRight: '5px' }}>
                  <img src={icoCat} alt="Catégorie" width={15} height={15} />
                </div>
                {props.category && (
                  <Text
                    mb={0}
                    className="category"
                    content={t('category.' + props.category)}
                  />
                )}
              </a>
            </Link>
            <Link href={`/${SEARCH_PAGE}/all?town=${props.town.trim()}`}>
              <a style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', marginRight: '5px' }}>
                  <img
                    src={icoLocation}
                    alt="Localisation"
                    width={12}
                    height={15}
                  />
                </div>
                {props.town && (
                  <Text mb={0} className="town" content={props.town} />
                )}
              </a>
            </Link>
          </SubCardInfosWrapper>
          <SubCardCenterWrapper>
            <SubCardTitleWrapper>
              <Link
                href={`/${SEARCH_PAGE}/${slugify(props.category)}/${slugify(
                  props.title
                )}-${props.sid}`}
              >
                <a style={{ alignItems: 'center', display: 'flex', maxWidth: '100%' }}>
                  <Certified certified={props.certified} size={20} style={{
                    color: '#00BCD4',
                    marginRight: 5,
                  }} />
                  <Text
                      content={props.title}
                      as="h2"
                      mt={12}
                      fontSize={18}
                      fontWeight={600}
                      color="#002F3F"
                      style={{
                        maxWidth: '100%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block',
                      }}
                  />
                </a>
              </Link>
            </SubCardTitleWrapper>
            {price}
            <SubCardDescriptionWrapper>
              <ReadMore character={115} more={''} less={''}>
                {props.description}
              </ReadMore>
            </SubCardDescriptionWrapper>
            {isAdmin() && (
              <div style={{ margin: '10px 0 0' }}>
                <strong style={{ color: '#ccc', fontSize: 12 }}>
                  {props.userName}
                </strong>
              </div>
            )}
          </SubCardCenterWrapper>
          <AddressAndDate>
            <div style={{ display: 'flex' }}>
              <img
                src={icoCalendar}
                alt="Localisation"
                style={{ marginRight: '5px', marginTop: -1 }}
              />
              <Text
                content={dateFormat(props.createdAt, t)}
                as="span"
                fontSize={12}
                fontWeight={400}
                color="#8C8C8C"
                mb={0}
                translate={false}
              />
            </div>
            <div style={{ display: 'flex' }}>
              {alreadyFavorite() ? (
                <img
                  src={heart}
                  alt={t('deleteFavs')}
                  style={{
                    marginRight: '5px',
                    position: 'relative',
                    zIndex: 101,
                  }}
                  color="#00BCD4"
                  onClick={handleFavourite}
                />
              ) : (
                <img
                  src={heartO}
                  alt={t('profile.favorites.add')}
                  style={{
                    marginRight: '5px',
                    position: 'relative',
                    zIndex: 101,
                  }}
                  color="#595959"
                  onClick={handleFavourite}
                />
              )}
            </div>
          </AddressAndDate>
          <Link
            href={`/${SEARCH_PAGE}/${slugify(props.category)}/${slugify(
              props.title
            )}-${props.sid}`}
          >
            <a
              aria-label={props.title}
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                zIndex: 9,
              }}
            />
          </Link>
        </ContentWrap>
      </ListViewWrapper>
      {props.ads && (props.indexLoop + 1) % 6 === 0 && (
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
          }}
        >
          <SkazyAdvertising
            name="list"
            zone={{ n: process.env.SKAZY_AD_LIST_N, id: process.env.SKAZY_AD_LIST_ID }}
            height={90}
            width="100%"
            containerStyle={{ marginTop: 10 }}
          />
        </div>
      )}
      {props.ads && isMobile && props.indexLoop === 8 && (
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
          }}
        >
          <SkazyAdvertising
            name="encart2"
            zone={{
              n: process.env.SKAZY_AD_ENCART_BOTTOM_N,
              id: process.env.SKAZY_AD_ENCART_BOTTOM_ID,
            }}
            height={250}
            width={300}
            containerStyle={{ marginTop: 10 }}
          />
        </div>
      )}
    </>
  );
};

export default ListView;
